const defaults = {
    baseUrl: process.env.REACT_APP_USERPAGE_API_URL || '/api',
};

// const meta = document.querySelector('meta[name="csrf-token"]');
// const csrfToken = meta ? meta.content : undefined;

const ApiError = (status, statusText) => {
    const error = Error(statusText);
    error.status = status;
    error.type = 'api';
    return error;
};

function urlSearch(obj) {
    if (typeof obj !== 'object') return '';
    const arr = [];

    for (let prop in obj) {
        const val = obj[prop];
        if (val !== null && val !== undefined) arr.push(`${prop}=${val}`);
    }

    return arr.length > 0 ? '?' + arr.join('&') : '';
}

const ValidationError = (errors) => {
    const error = new Error('Validation error');
    error.type = 'validation';
    error.errors = errors;
    return error;
};

const AuthorizationError = (message) => {
    const error = new Error(message);
    error.type = 'authorization';
    return error;
};

function isAbsolute(endpoint) {
    return endpoint.startsWith('http://') || endpoint.startsWith('https://');
}

export class BaseApi {
    constructor(options) {
        this.options = { ...defaults, ...options };
    }

    get(endpoint) {
        return this.request(endpoint);
    }

    post(endpoint, body) {
        return this.request(endpoint, { method: 'POST', body });
    }

    put(endpoint, body) {
        return this.request(endpoint, { method: 'PUT', body });
    }

    delete(endpoint) {
        return this.request(endpoint, { method: 'DELETE' });
    }

    async request(endpoint, options) {
        if (Array.isArray(endpoint)) {
            let params;
            [endpoint, params] = endpoint;
            endpoint = endpoint + urlSearch(params);
        }

        if (!isAbsolute(endpoint)) endpoint = this.options.baseUrl + endpoint;

        const { method, headers, body, ...rest } = { method: 'GET', ...options };

        const response = await fetch(endpoint, {
            method: ['PUT', 'DELETE'].includes(method.toUpperCase()) ? 'POST' : method,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-HTTP-Method-Override': method.toUpperCase(),
                // 'X-CSRF-Token': csrfToken,
                ...headers,
            },
            body: body ? JSON.stringify(body) : undefined,
            ...rest,
        });

        if (!response.ok) {
            switch (response.status) {
                case 400: {
                    const { errors } = await response.json();
                    throw ValidationError(errors);
                }
                case 401:
                case 403:
                    throw AuthorizationError(response.statusText);
                default:
                    throw ApiError(response.status, response.statusText);
            }
        }

        if (response.status !== 204) {
            return response.json();
        }
    }
}

export default (options) => new BaseApi(options);
